import { NgModule } from '@angular/core';
import { RuleEngineService } from './rule-engine.service';
import { RuleFactoryService, RULE_FACTORY_SERVICE } from './rule-factory.service';

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [RuleEngineService, RuleFactoryService, { provide: RULE_FACTORY_SERVICE, useClass: RuleFactoryService }],
})
export class RuleEngineModule {}
